import { Avatar, Box } from '@mui/material';
import { singleFileDownloadUrlGeneratorFromFhirUrl } from '../../http-common';
import { handleMimeType } from '../../config/common';

const AvatarRenderer = props => {
  console.log(`Avatar renderer`, props);
  return (
    <>
      {props?.value === 'not_found' || props?.data?.avatar === 'not_found' ? (
        <div>No Data Found</div>
      ) : (
        <Box sx={{ display: 'flex' }}>
          {props?.data?.avatar?.url ? (
            <Avatar
              src={singleFileDownloadUrlGeneratorFromFhirUrl({
                fileNameUrl: props?.data?.avatar?.url,
                type: handleMimeType(props?.data?.avatar?.url),
              })}
              alt={props?.value?.name}
              sx={{
                height: 35,
                width: 35,
                overflow: 'hidden',
                '& > img': {
                  width: '100%',
                  height: '100%',
                  objectFit: 'fill',
                },
                border: '1px solid lightgray',
              }}
            />
          ) : (
            <Avatar sx={{ height: 35, width: 35 }} />
          )}
        </Box>
      )}
    </>
  );
};

export default AvatarRenderer;
